import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-sub-project-v2',
  templateUrl: './sub-project-v2.component.html',
  styleUrls: ['./sub-project-v2.component.scss']
})
export class SubProjectV2Component implements OnInit {
  tenantId: string;
  subProjectForm
  currentProjectId: any;
  currentUser: any;
  // row data and column definitions
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
    userDetails: any;
    selectedFile: File;
    jsonData: any;
    gridApi: any;
    gridColumnApi: any;
    form: FormGroup;
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    selectedCheckboxData = []
    deleteConfirmationMsg = 'Are you sure you want to delete'
    projectId: any;
    parentProjectId: any;
    isAdministrator: boolean = false;
    isPMOAdmin: boolean = false;
  
  constructor(
    private projectService: ProjectService,  
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private storageService: LocalStorageService,
    private router: Router
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.subProjectForm = new FormGroup({
      id: new FormControl(''),
      projectName: new FormControl(''),
      projectCode: new FormControl(''),
      projectDescription: new FormControl(''),
      projectManagerId: new FormControl(''),
      projectManagerName: new FormControl(''),
      projectLeadId: new FormControl(''),
      projectLeadName: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      decisionDate: new FormControl(''),
      customer: new FormControl(''),
      status: new FormControl(''),
      createdByUserId: new FormControl(''),
      createdByUserName: new FormControl(''),
      totalHours: new FormControl(''),
      remainingHours: new FormControl(''),
      percentageCompleted: new FormControl(''),
      regionId: new FormControl(''),
      regionName: new FormControl(''),
      industryId: new FormControl(''),
      industryName: new FormControl(''),
      businessGroupId: new FormControl(''),
      businessGroupName: new FormControl(''),
      commodityId: new FormControl(''),
      activityId: new FormControl(''),
      activityName: new FormControl(''),
      projectSoftwareId: new FormControl(''),
      projectSoftwareName: new FormControl(''),
      parentProjectId: new FormControl(''),
      parentProjectName: new FormControl(''),
      parentProjectCode: new FormControl(''),
    })
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.userDetails.roles.includes('RolePmoAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.currentProjectId;
    this.getSubProjects();
  }

  getSubProjects() {
    if(this.isAdministrator){
      this.projectService.getSubProjectsV2(this.parentProjectId).subscribe((response: any) => {
        this.rowData = response;
      });
    } else{
      this.projectService.getSubProjectV2ByUserId(this.userDetails.id, this.parentProjectId).subscribe((response: any) => {
        this.rowData = response;
      });
    }
  }

    // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
    onGridReady(params): void {
      this.api = params.api;
      this.columnApi = params.columnApi;
      this.api.sizeColumnsToFit();
    }  

    // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: "Sub Project",
        field: "projectName",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: "Project Code",
        field: "projectCode",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Name",
        field: "parentProjectName",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Customer",
        field: "customer",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Manager",
        field: "projectManagerName",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "% of Completion",
        field: "percentageCompleted",
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      {
        headerName: "ProjectStatus",
        field: "status",
        hide: true,
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Total Hours",
        field: "totalHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Remaining Hours",
        field: "remainingHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      }
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  openSubProject(){
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/sub-projectform-v2'], { queryParams: { parentId: this.parentProjectId } });
  }

  backToMyProjectV2() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/myproject-v2']);
  }

  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
  }


  updateSubProject() {
    let currentProjectId = this.selectedCheckboxData[0].id; 
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/sub-projectform-v2'], { queryParams: { projectID: currentProjectId, parentId: this.parentProjectId } });
  }

  // performGridActionItem(params) {
  //   if (params.event.currentTarget.value == 'delete') {
  //     this.deleteGridRow(params);
  //   }    
  // }

  // private deleteGridRow(params: any) {
  //   this.projectService.deleteProject(params.params.data.id).subscribe(() => {
  //     var selectedData = params.params.data;
  //     this.api.applyTransaction({ remove: [selectedData] });
  //   });
  // }
}
